module.exports = __webpack_public_path__ + "static/026.thumb-b772e46a5e680a9546539a04f7dfe0d8.jpg";